import "./Download.module.css";
import Header from "@/reusable_sections/Header";
import PremiumEditorialEntrance from "./sections/PremiumEditorialEntrance";
import SeamlessMultiscreen from "./sections/SeamlessMultiscreen";
import DermatologistApproved from "./sections/DermatologistApproved";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function DownloadPage() {
  return <div>
      <Header />
      <PremiumEditorialEntrance />
      <SeamlessMultiscreen />
      <DermatologistApproved />
      <MainSiteFooter />
    </div>;
}